//Custom components
import StatCard from '../../../UI/Card/StatCard';
import { CurrencyFormatDisplay } from '../../../UI/NumberFormatDisplay/CurrencyFormatDisplay';

const CityInvestmentWidget = ({ count }: { count: number | string }) => {
  return <StatCard title='City Investment' stat={<CurrencyFormatDisplay value={count} prefix='$' />} />;
};

export default CityInvestmentWidget;
